export default "__VITE_ASSET__Cs6vMDzu__"